import { totalCustoVenda, totalDespesaVenda, totalImpostos } from '../../calculos';

export const outrosCustosComercialCalc = data => {
  const impostos = totalImpostos(data.impostos);
  const custoVenda = totalCustoVenda(data);
  const despesaVenda = totalDespesaVenda(data);
  const total = (impostos + custoVenda + despesaVenda) * 0.01 * data.precoMedioUfCanal;

  return total;
};

export const PMZComercialCalc = data => {
  return outrosCustosComercialCalc(data) + data.parametros.custoFabricacao;
};

export const descontoMaximoTagCalc = (desconto, preco) => {
  const calc = (1 - desconto / 100) * preco;
  return calc || 0;
};

export const margemOperacionalTagCalc = (PMZ, preco) => {
  const calc = ((preco - PMZ) / preco) * 100;
  return calc || 0;
};

export const applyDiscount = (desconto, preco) => {
  return preco - preco * (desconto / 100);
};

export const tabelaAtualComercialPercentage = data => {
  const value = data.parametros.precoTabela;
  const calc = ((value - PMZComercialCalc(data)) / value) * 100;

  return calc.toFixed(2).toString().replace('.', ',');
};
